export const RWA_SHARED_ERC1155_ABI = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "name_",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "symbol_",
        "type": "string"
      },
      {
        "internalType": "address[]",
        "name": "initialMinters",
        "type": "address[]"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "ApprovalForAll",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "MinterUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "indexed": false,
        "internalType": "uint256[]",
        "name": "values",
        "type": "uint256[]"
      }
    ],
    "name": "TransferBatch",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "TransferSingle",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "accounts",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      }
    ],
    "name": "balanceOfBatch",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "burn",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      }
    ],
    "name": "isApprovedForAll",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "name": "mint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "minters",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "amounts",
        "type": "uint256[]"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "name": "safeBatchTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "setApprovalForAll",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "setMinter",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes4",
        "name": "interfaceId",
        "type": "bytes4"
      }
    ],
    "name": "supportsInterface",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];

export const RWA_SHARED_ERC1155_BYTECODE = "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";

export const RWA_SHARED_ERC1155_SOLIDITY_SOURCE = "// SPDX-License-Identifier: MIT\r\npragma solidity ^1.1.2;\r\n\r\nimport \"openzeppelin-contracts/utils/Context.sol\";\r\nimport \"openzeppelin-contracts/utils/Checksum.sol\";\r\n\r\n/**\r\n * @title RwaSharedErc1155\r\n * @notice Minimal multi-token catalog on Core `Context` + `Checksum` (OpenZeppelin Core, commodity-units style).\r\n *         No CRC1155 base in this OZ fork — logic matches the prior catalog surface.\r\n */\r\ncontract RwaSharedErc1155 is Context {\r\n    string public name;\r\n    string public symbol;\r\n    address public owner;\r\n\r\n    mapping(uint256 => mapping(address => uint256)) private _balances;\r\n    mapping(address => mapping(address => bool)) private _operatorApprovals;\r\n    mapping(address => bool) public minters;\r\n\r\n    event TransferSingle(\r\n        address indexed operator,\r\n        address indexed from,\r\n        address indexed to,\r\n        uint256 id,\r\n        uint256 value\r\n    );\r\n    event TransferBatch(\r\n        address indexed operator,\r\n        address indexed from,\r\n        address indexed to,\r\n        uint256[] ids,\r\n        uint256[] values\r\n    );\r\n    event ApprovalForAll(address indexed account, address indexed operator, bool approved);\r\n    event MinterUpdated(address indexed account, bool allowed);\r\n\r\n    function _isZeroLike(address account) private view returns (bool) {\r\n        return account == address(0) || account == Checksum.zeroAddress();\r\n    }\r\n\r\n    constructor(string memory name_, string memory symbol_, address[] memory initialMinters) {\r\n        owner = _msgSender();\r\n        name = name_;\r\n        symbol = symbol_;\r\n        for (uint256 i = 0; i < initialMinters.length; i++) {\r\n            address a = initialMinters[i];\r\n            if (!_isZeroLike(a)) {\r\n                minters[a] = true;\r\n                emit MinterUpdated(a, true);\r\n            }\r\n        }\r\n    }\r\n\r\n    function setMinter(address account, bool allowed) external {\r\n        require(_msgSender() == owner, \"Only owner\");\r\n        require(!_isZeroLike(account), \"Zero minter\");\r\n        minters[account] = allowed;\r\n        emit MinterUpdated(account, allowed);\r\n    }\r\n\r\n    function supportsInterface(bytes4 interfaceId) external pure returns (bool) {\r\n        return interfaceId == 0x01ffc9a7 || interfaceId == 0xd9b67a26;\r\n    }\r\n\r\n    function balanceOf(address account, uint256 id) public view returns (uint256) {\r\n        require(!_isZeroLike(account), \"Zero address\");\r\n        return _balances[id][account];\r\n    }\r\n\r\n    function balanceOfBatch(address[] calldata accounts, uint256[] calldata ids) external view returns (uint256[] memory) {\r\n        require(accounts.length == ids.length, \"Length\");\r\n        uint256[] memory batch = new uint256[](accounts.length);\r\n        for (uint256 i = 0; i < accounts.length; i++) {\r\n            batch[i] = balanceOf(accounts[i], ids[i]);\r\n        }\r\n        return batch;\r\n    }\r\n\r\n    function setApprovalForAll(address operator, bool approved) external {\r\n        address sender = _msgSender();\r\n        _operatorApprovals[sender][operator] = approved;\r\n        emit ApprovalForAll(sender, operator, approved);\r\n    }\r\n\r\n    function isApprovedForAll(address account, address operator) public view returns (bool) {\r\n        return _operatorApprovals[account][operator];\r\n    }\r\n\r\n    function safeTransferFrom(\r\n        address from,\r\n        address to,\r\n        uint256 id,\r\n        uint256 amount,\r\n        bytes calldata /* data */\r\n    ) external {\r\n        address sender = _msgSender();\r\n        require(!_isZeroLike(to), \"Zero to\");\r\n        require(to.code.length == 0, \"EOA only\");\r\n        require(from == sender || isApprovedForAll(from, sender), \"Not approved\");\r\n        _balances[id][from] -= amount;\r\n        _balances[id][to] += amount;\r\n        emit TransferSingle(sender, from, to, id, amount);\r\n    }\r\n\r\n    function safeBatchTransferFrom(\r\n        address from,\r\n        address to,\r\n        uint256[] calldata ids,\r\n        uint256[] calldata amounts,\r\n        bytes calldata /* data */\r\n    ) external {\r\n        address sender = _msgSender();\r\n        require(!_isZeroLike(to), \"Zero to\");\r\n        require(to.code.length == 0, \"EOA only\");\r\n        require(from == sender || isApprovedForAll(from, sender), \"Not approved\");\r\n        require(ids.length == amounts.length, \"Length\");\r\n        for (uint256 i = 0; i < ids.length; i++) {\r\n            uint256 id = ids[i];\r\n            uint256 amt = amounts[i];\r\n            _balances[id][from] -= amt;\r\n            _balances[id][to] += amt;\r\n        }\r\n        emit TransferBatch(sender, from, to, ids, amounts);\r\n    }\r\n\r\n    function mint(address to, uint256 id, uint256 amount, bytes calldata /* data */) external {\r\n        address sender = _msgSender();\r\n        require(sender == owner || minters[sender], \"Not minter\");\r\n        require(!_isZeroLike(to), \"Zero to\");\r\n        _balances[id][to] += amount;\r\n        emit TransferSingle(sender, address(0), to, id, amount);\r\n    }\r\n\r\n    function burn(address from, uint256 id, uint256 amount) external {\r\n        address sender = _msgSender();\r\n        require(sender == owner || minters[sender] || from == sender, \"Not authorized\");\r\n        _balances[id][from] -= amount;\r\n        emit TransferSingle(sender, from, address(0), id, amount);\r\n    }\r\n}\r\n";

export const RWA_SHARED_ERC1155 = {
  contractName: "RwaSharedErc1155",
  abi: RWA_SHARED_ERC1155_ABI,
  abiJson: JSON.stringify({ abi: RWA_SHARED_ERC1155_ABI, methodIdentifiers: {"balanceOf(address,uint256)":"c5524546","balanceOfBatch(address[],uint256[])":"055ec16d","burn(address,uint256,uint256)":"7f055188","isApprovedForAll(address,address)":"a333775e","mint(address,uint256,uint256,bytes)":"f1b91403","minters(address)":"d6599743","name()":"07ba2a17","owner()":"be0e67a3","safeBatchTransferFrom(address,address,uint256[],uint256[],bytes)":"36aa5a49","safeTransferFrom(address,address,uint256,uint256,bytes)":"abfbcbd5","setApprovalForAll(address,bool)":"cc7a5b40","setMinter(address,bool)":"59b62736","supportsInterface(bytes4)":"80ada41b","symbol()":"231782d8"} }),
  bytecode: RWA_SHARED_ERC1155_BYTECODE,
  mintFunctionName: "mint",
  soliditySource: RWA_SHARED_ERC1155_SOLIDITY_SOURCE,
  sourceFileName: "RwaSharedErc1155.sol"
};
